import { Link } from "react-router-dom";

interface PaywallModalProps {
  onClose: () => void;
}

export default function PaywallModal({ onClose }: PaywallModalProps) {
  return (
    <div
      style={{
        position: "fixed", inset: 0,
        background: "rgba(0,0,0,0.75)",
        display: "flex", alignItems: "center", justifyContent: "center",
        zIndex: 1000,
      }}
      onClick={(e) => e.target === e.currentTarget && onClose()}
    >
      <div
        className="glass"
        style={{
          padding: "40px 48px", maxWidth: 480, width: "90%",
          textAlign: "center",
        }}
      >
        <div style={{ fontSize: 40, marginBottom: 14 }}>🌍</div>
        <h2 style={{ margin: "0 0 10px", fontSize: 22, fontWeight: 700, color: "#EFF2F5" }}>
          You've used your 3 free probes
        </h2>
        <p style={{ color: "#98A1AB", fontSize: 15, margin: "0 0 32px", lineHeight: 1.6 }}>
          Sign up for free to get 20 probes per day, or go Pro for unlimited
          monitoring, scheduled checks, and latency alerts.
        </p>
        <div style={{ display: "flex", flexDirection: "column", gap: 12 }}>
          <Link
            to="/sign-up"
            className="btn-primary"
            style={{ display: "block", padding: "13px 0", fontSize: 15, textDecoration: "none" }}
          >
            Sign up free — 20 probes/day
          </Link>
          <Link
            to="/upgrade"
            className="btn-glass"
            style={{ display: "block", padding: "13px 0", fontSize: 15, textAlign: "center", textDecoration: "none" }}
          >
            Start Pro — $12/month
          </Link>
          <button
            onClick={onClose}
            style={{
              background: "none", border: "none",
              color: "#98A1AB", fontSize: 13,
              cursor: "pointer", padding: 0, fontFamily: "inherit",
            }}
          >
            Maybe later
          </button>
        </div>
      </div>
    </div>
  );
}
